'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _constants = require('../constants');
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  switch (action.type) {
    case _constants.actionTypes.RESET_FIELDS:
    case _constants.actionTypes.SET_VALUE:
    case _constants.actionTypes.SET_VALUES:
      {
        return false;
      }
    case _constants.actionTypes.VALIDATE_FORM:
      {
        var valid = true;
        Object.keys(action.errors).forEach(function (name) {
          if (action.errors[name]) {
            valid = false;
          }
        });
        return valid;
      }
    default:
      return state;
  }
};